import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'coursefilter',
    pure: true
})
export class CourseFilterPipe implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (!items || !filter || filter === '') {
            return items;
        }
        return items.filter(item => {
             return +item['category'] === +filter;
        });
}
}
